// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(
    0,
    0,
    0,
    0.7
  ); /* Un poco más oscuro para resaltar la animación */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999 !important;
  flex-direction: column;
  gap: 20px;
  backdrop-filter: blur(4px);
}

.truck-wrapper {
  animation: truck-bounce 0.6s infinite ease-in-out alternate;
}

/* Animación de "rebote" del camión (suspensión) */
@keyframes truck-bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-3px);
  }
}

/* Ruedas girando */
.wheel {
  transform-box: fill-box;
  transform-origin: center;
  animation: wheel-spin 0.6s linear infinite;
}

@keyframes wheel-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Líneas de viento pasando */
.wind {
  animation: wind-move 0.8s linear infinite;
}
.wind-1 {
  animation-delay: 0s;
}
.wind-2 {
  animation-delay: 0.4s;
}

@keyframes wind-move {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    transform: translateX(-15px);
    opacity: 0;
  }
}

.loading-text {
  color: white;
  font-size: 1.2rem;
  font-weight: 500;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoadingOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb;;;;;GAKC,EAAE,kDAAkD;EACrD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,kDAAkD;AAClD;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C","sourcesContent":[".loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(\n    0,\n    0,\n    0,\n    0.7\n  ); /* Un poco más oscuro para resaltar la animación */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999999 !important;\n  flex-direction: column;\n  gap: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.truck-wrapper {\n  animation: truck-bounce 0.6s infinite ease-in-out alternate;\n}\n\n/* Animación de \"rebote\" del camión (suspensión) */\n@keyframes truck-bounce {\n  from {\n    transform: translateY(0);\n  }\n  to {\n    transform: translateY(-3px);\n  }\n}\n\n/* Ruedas girando */\n.wheel {\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: wheel-spin 0.6s linear infinite;\n}\n\n@keyframes wheel-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Líneas de viento pasando */\n.wind {\n  animation: wind-move 0.8s linear infinite;\n}\n.wind-1 {\n  animation-delay: 0s;\n}\n.wind-2 {\n  animation-delay: 0.4s;\n}\n\n@keyframes wind-move {\n  0% {\n    transform: translateX(0);\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-15px);\n    opacity: 0;\n  }\n}\n\n.loading-text {\n  color: white;\n  font-size: 1.2rem;\n  font-weight: 500;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
